import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import VOPModal from "./VOPModal"
import GDPRModal from "./GDPRModal"
import LicensesModal from "./LicensesModal"
import CookiesModal from "./CookiesModal"
import ContactModal from "./ContactModal"
import AboutUsModal from "./AboutUsModal"
import FaqModal from "./FaqModal"
import AdvertisingTermsModal from "./AdvertisingTermsModal"
import { showFloatingPromoBannerFromClickable } from "../utils/promoBannerEvents"
import UniqueVisitCounter from "./UniqueVisitCounter"

const Footer = () => {
  const { t } = useTranslation()

  const [hovered, setHovered] = useState(null)

  const [openVOP, setOpenVOP] = useState(false)
  const [openGDPR, setOpenGDPR] = useState(false)
  const [openLicenses, setOpenLicenses] = useState(false)
  const [openCookies, setOpenCookies] = useState(false)
  const [openContact, setOpenContact] = useState(false)
  const [openFAQ, setOpenFAQ] = useState(false)
  const [openAdvertisingTerms, setOpenAdvertisingTerms] = useState(false)
  const [openAboutUs, setOpenAboutUs] = useState(false)

const links = [
  { href: "/terms", label: t("TERMS") },
  { href: "/advertising-terms", label: t("ADVERTISING_TERMS") },
  { href: "/privacy", label: t("PRIVACY") },
  { href: "/faq", label: t("FAQ_TITLE") },
  { href: "/about-us", label: t("ABOUT_US") },
  { href: "/cookies", label: t("COOKIES") },
  { href: "/licenses", label: t("LICENSES") },
  { href: "/contact", label: t("CONTACT") }
]

  return (
    <>
      <footer
        onClickCapture={showFloatingPromoBannerFromClickable}
        style={{
          position: "relative",
          padding: "7px 20px",
          textAlign: "center",
          backgroundColor: "#0A303B",
          overflow: "hidden",
          fontSize: 14
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: "url('/pattern_6.png')",
            backgroundRepeat: "repeat",
            backgroundSize: "400px 400px",
            opacity: 0.1,
            pointerEvents: "none"
          }}
        />

        <UniqueVisitCounter />

        <div
          style={{
            position: "relative",
            color: "#E7DFEC",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 4,
            flexWrap: "wrap"
          }}
        ><button
  type="button"
  onClick={() => setOpenAboutUs(true)}
  onMouseEnter={() => setHovered("about-us")}
  onMouseLeave={() => setHovered(null)}
  style={{
    color: "#E7DFEC",
    background: hovered === "about-us"
      ? "rgba(0,0,0,0.75)"
      : "transparent",
    border: 0,
    padding: "4px 2px",
    borderRadius: 8,
    cursor: "pointer",
    font: "inherit",
    boxShadow: hovered === "about-us"
      ? "0 6px 20px rgba(0,0,0,0.65)"
      : "none",
    transition: "all 0.12s ease"
  }}
>
  © 2026 EnerqiQ Net
</button>
          <span>– {t("ALL_RIGHTS_RESERVED")}</span>

          <span style={{ opacity: 0.6 }}>|</span>

          {links.map((link, i) => {
            const isHover = hovered === i

            return (
              <React.Fragment key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => {
                    if (link.href === "/terms") {
                      e.preventDefault()
                      setOpenVOP(true)
                    }

		    if (link.href === "/advertising-terms") {
 		     e.preventDefault()
 		     setOpenAdvertisingTerms(true)
		    }

                    if (link.href === "/privacy") {
                      e.preventDefault()
                      setOpenGDPR(true)
                    }

                    if (link.href === "/licenses") {
                      e.preventDefault()
                      setOpenLicenses(true)
                    }

                    if (link.href === "/cookies") {
                      e.preventDefault()
                      setOpenCookies(true)
                    }

                    if (link.href === "/faq") {
                      e.preventDefault()
                      setOpenFAQ(true)
                    }

	  	    if (link.href === "/about-us") {
 		     e.preventDefault()
		      setOpenAboutUs(true)
		    }

                    if (link.href === "/contact") {
                      e.preventDefault()
                      setOpenContact(true)
                    }
                  }}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                  style={{
                    color: "#E7DFEC",
                    textDecoration: "none",
                    padding: "4px 6px",
                    borderRadius: 8,
                    background: isHover
                      ? "rgba(0,0,0,0.75)"
                      : "transparent",
                    boxShadow: isHover
                      ? "0 6px 20px rgba(0,0,0,0.65)"
                      : "none",
                    transition: "all 0.12s ease",
                    cursor: "pointer"
                  }}
                >
                  {link.label}
                </a>

                {i < links.length - 1 && (
                  <span style={{ opacity: 0.6 }}>|</span>
                )}
              </React.Fragment>
            )
          })}
        </div>
      </footer>

      <VOPModal
        open={openVOP}
        onClose={() => setOpenVOP(false)}
      />

	<AdvertisingTermsModal
	  open={openAdvertisingTerms}
	  onClose={() => setOpenAdvertisingTerms(false)}
 	 openedFrom="link"
	/>

      <GDPRModal
        open={openGDPR}
        onClose={() => setOpenGDPR(false)}
        openedFrom="link"
      />

      <LicensesModal
        open={openLicenses}
        onClose={() => setOpenLicenses(false)}
        openedFrom="link"
      />

      <CookiesModal
        open={openCookies}
        onClose={() => setOpenCookies(false)}
        openedFrom="link"
      />

      <FaqModal
        open={openFAQ}
        onClose={() => setOpenFAQ(false)}
      />

      <ContactModal
        open={openContact}
        onClose={() => setOpenContact(false)}
      />

      <AboutUsModal
        open={openAboutUs}
        onClose={() => setOpenAboutUs(false)}
      />
    </>
  )
}

export default Footer